const { instance } = require('./url')
const { ObjectToParams } = require('./urlparser')
const {JustDate} = require('../JustDate')
const {Quote} = require('../Quote')

const MACHINE_NAMES = [
      "HAAS1",
      "HAAS2",
      "HAAS3",
      "HAAS4",
      "HAAS5",
      "HAAS6",
]

const IMPERFECTIONS = [
    {
        'display_name': 'Webbing',
        'var_name': 'floor_deeper',
    },
    {
        'display_name': 'Lines',
        'var_name': 'floor_lines',
    },
    {
        'display_name': 'Pitted Lines',
        'var_name': 'pitted_lines',
    },
    {
        'display_name': 'Pitts',
        'var_name': 'pitts',
    },
    {
        'display_name': 'Chipped Letters',
        'var_name': 'chipped_letters',
    },
    {
        'display_name': 'Reverse Webbing',
        'var_name': 'floor_shallow',
    },
    {
        'display_name': 'Flat Braille',
        'var_name': 'flat_braille',
    },
    {
        'display_name': 'Sharp Braille',
        'var_name': 'sharp_braille',
    },
    {
        'display_name': 'Dwell Marks',
        'var_name': 'dwel_marks',
    },
    {
        'display_name': 'Remake',
        'var_name': 'remake',
    },
]

async function getLatestMachine(machine) {
    const response = await instance.get('/milling/machine/' + machine)
    return response.data
}

async function getLatest() {
    let plates = [];
  
    for (const machine of MACHINE_NAMES) {
        plates.push(await getLatestMachine(machine));
    }

    return plates;
}

async function getPlatesFromMachineTime(machine, startTime, endTime) {
    const response = await instance.post('/milling/machine/' + machine, {
        "machine": machine,
        "start": startTime,
        "end": endTime,
    })
    for (let i = 0; i < response.data.length; i++) {
        if (!response.data[i].tool_info) {
            response.data[i].tool_info = []
        }
        if (!response.data[i].imperfections) {
            response.data[i].imperfections = []
        }
    }
    return response.data
}

async function getPlatesFromTime(startTime, endTime) {
    let plates = []
    for (const machine of MACHINE_NAMES) {
        plates = [...plates, ...await getPlatesFromMachineTime(machine, startTime, endTime)]
    }
    return plates
}

async function getPlatesFromJob(job) {
    const response = await instance.get('/milling/job/' + job)

    for (let i = 0; i < response.data.length; i++) {
        if (!response.data[i].tool_info) {
            response.data[i].tool_info = []
        }
    }

    return response.data
}

async function updatePlate(plate) {
    const response = await instance.put('/milling/file', plate)
    return response.data
}

export {
    MACHINE_NAMES,
    IMPERFECTIONS,
    getLatestMachine,
    getLatest,
    getPlatesFromJob,
    updatePlate,
    getPlatesFromMachineTime,
    getPlatesFromTime,
}

